import { useState } from "react";
import { Button } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { getAnalyticsConsent, setAnalyticsConsent } from "../firebase";

export const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => getAnalyticsConsent() === null);

  if (!visible) return null;

  const handleAccept = () => {
    setAnalyticsConsent("accepted");
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    setAnalyticsConsent("rejected");
    setVisible(false);
  };

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: "var(--bulma-scheme-main-bis, #fafafa)",
      borderTop: "1px solid var(--bulma-border, #dbdbdb)",
      padding: "1rem",
    }}>
      <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "0.75rem" }}>
        <p style={{ margin: 0, flex: 1, minWidth: "200px" }}>
          {t("consent.message")}{" "}
          <a href="/privacy">{t("consent.learnMore")}</a>
        </p>
        <div style={{ display: "flex", gap: "0.5rem", flexShrink: 0 }}>
          <Button size="small" onClick={handleEssentialOnly}>
            {t("consent.essentialOnly")}
          </Button>
          <Button size="small" color="info" onClick={handleAccept}>
            {t("consent.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
};
